import { useState, useCallback, FC } from 'react';
import { copyToClipboard } from 'utils/clipboard';
import { ContentModal } from './ContentModal';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  textToShare: string;
};

export const ShareTipsPopup: FC<Props> = ({ isOpen, onClose, textToShare }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    await copyToClipboard(textToShare);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }, [textToShare]);

  return (
    <ContentModal
      isOpen={isOpen}
      onClose={onClose}
      title="Share the below with your family & friends"
      buttonText={copied ? 'Copied!' : 'COPY TEXT'}
      onButtonClick={handleCopy}
    >
      {textToShare.split('\n\n').map((paragraph, i) => (
        <p key={i}>{paragraph}</p>
      ))}
    </ContentModal>
  );
};
